export default __webpack_public_path__ + "static/assets/ecd34a51965de9cc31cf3b2e9167054f.jpg";